import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { SRBMMonitoringHistoryData } from 'api/traps/SRBMTraps/types';
import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';

interface SBSMonitoringHistoryExpandableProps {
  data: SRBMMonitoringHistoryData;
  slug?: string;
}
const SBSMonitoringHistoryExpandable: React.FC<SBSMonitoringHistoryExpandableProps> = ({ data }) => {
  const { t } = useTranslation();
  const mobile = useMediaQuery(MediaBreakpoints.mobile);
  const tablet = useMediaQuery(MediaBreakpoints.tablet);
  const desktop = useMediaQuery(MediaBreakpoints.desktop);

  return (
    <div className="d-flex w-100 flex-column">
      {mobile && (
        <div className="d-flex flex-column my-2 mx-3">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('MCTDetail.TrapHistoryCard.battery')}</span>
          </div>
          <div>{data.battery_percentage}</div>
        </div>
      )}

      {tablet && (
        <div className="d-flex flex-lg-row  my-2">
          <div className="mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('MCTDetail.TrapHistoryCard.crmDateTime')}</span>
            </div>
            <div>{dayjs(data.crm_date_time).format('DD-MM-YYYY\xa0\xa0\xa0HH:mm:ss')}</div>
          </div>
        </div>
      )}

      {desktop && (
        <div className="d-flex flex-lg-row  my-2">
          <div className="mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('MCTDetail.TrapHistoryCard.token')}</span>
            </div>
            <div>{data.msg_token}</div>
          </div>
          <div className="mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('MCTDetail.TrapHistoryCard.rrsi')}</span>
            </div>
            <div>{data.rssi}</div>
          </div>
          <div className="mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('MCTDetail.TrapHistoryCard.snr')}</span>
            </div>
            <div>{data.snr}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SBSMonitoringHistoryExpandable;
